<div class="dialog">
  @if (isMobileView()) {
    <header class="mobile-app-bar sticky-header">
      <p (click)="close()" [ngStyle]="{ cursor: 'pointer' }" translate>Cancel</p>
      <h2 class="mobile-app-bar__heading">{{ 'Course' | translate }} {{ (_currentSelectedCourse ? 'Edit' : 'Create') | translate | lowercase }}</h2>
      <p [ngStyle]="{ cursor: 'pointer' }" class="disabled" disabled="true" translate>Save</p>
    </header>
  }

  @if (!isMobileView()) {
    <header class="dialog__header">
      <h3 class="dialog__header__title">{{ 'Course' | translate }} {{ (_currentSelectedCourse ? 'Edit' : 'Create') | translate | lowercase }}</h3>
      <div class="dialog__header__action-buttons">
        <div (click)="close()" class="dialog__header__action-buttons__button">
          <span>
            <app-icon [cssStyle]="{ 'margin-top': '3px', cursor: 'pointer' }" iconName="close" size="14px"></app-icon>
          </span>
        </div>
      </div>
    </header>
  }

  <div class="dialog__content">
    <form [formGroup]="form" action="" class="form">
      <div class="align-fields">
        <div>
          <!-- Image Selector -->
          <div class="input-group">
            <label for="image" translate>Image</label>
            <app-image-selector
              (imageSelected)="selectedImage = $event"
              [aspectRatio]="4 / 3"
              [entityId]="courseId"
              [fullWidthPreview]="true"
              [imageCropper]="true"
              [isUpdateMode]="isUpdateMode"
              [sectionType]="SectionType.COURSE"
              formControlName="image"
              id="image"
              name="image"
            ></app-image-selector>
            <!--            <app-form-error [control]="form.get('image')" [name]="'Image' | translate"></app-form-error>-->
          </div>

          <!-- Course Name -->
          <div class="input-group --required">
            <label for="courseName" translate>Course Name</label>
            <input [placeholder]="'Course Name' | translate" class="full-width-input" formControlName="name" id="courseName" name="courseName" type="text" />
            <app-form-error [control]="form.get('name')" [name]="'Course Name' | translate"></app-form-error>
          </div>

          <!-- Venue -->
          <div class="input-group --required">
            <label for="venue" translate>Add Location</label>
            <input [placeholder]="'Venue' | translate" class="full-width-input" formControlName="place" id="venue" name="venue" type="text" />
            <app-form-error [control]="form.get('place')" [name]="'Venue' | translate"></app-form-error>
          </div>
          <!-- Tags -->
          <div class="input-group">
            <label for="tags" translate>Add Tags</label>
            <ng-select
              [addTagText]="'Add Tag' | translate"
              [addTag]="addTagFn"
              [closeOnSelect]="true"
              [items]="tags"
              [multiple]="true"
              [notFoundText]="'No tags available' | translate"
              [placeholder]="'Select Tags' | translate"
              [searchable]="true"
              addTag="true"
              bindLabel="label"
              bindValue="value"
              class="custom"
              formControlName="courseTagsArray"
              id="tags"
              name="tags"
            ></ng-select>
            <!--            <app-form-error [control]="form.get('courseTagsArray')" [name]="'Tags' | translate"></app-form-error>-->
          </div>

          <!-- Instructor Types -->
          <div class="input-group --required">
            <label for="instructorType" translate>Instructor Type</label>
            <app-dropdown [options]="instructorTypes" bindValue="value" displayName="key" formControlName="instructorType" id="instructorType" name="instructorType"></app-dropdown>
            <app-form-error [control]="form.get('instructorType')" [name]="'Instructor Type' | translate"></app-form-error>
          </div>

          <!-- Internal Instructor -->
          @if (form.get('instructorType').value === CourseInstructorType.Internal) {
            <div class="input-group --required">
              <label for="internalInstructors" translate>Instructor</label>
              <ng-select
                [clearable]="false"
                [closeOnSelect]="true"
                [items]="internalInstructors"
                [multiple]="false"
                [placeholder]="'Select Options' | translate"
                [searchable]="true"
                bindLabel="fullName"
                bindValue="id"
                class="custom"
                formControlName="internalInstructorId"
                id="internalInstructors"
                name="internalInstructors"
              >
              </ng-select>
              <app-form-error [control]="form.get('internalInstructorId')" [name]="'Instructor' | translate"></app-form-error>
            </div>
          }

          <!-- External Instructor -->
          @if (form.get('instructorType').value === CourseInstructorType.External) {
            <div class="input-group --required">
              <label for="externalInstructors" translate>Instructor</label>
              <ng-select
                [clearable]="false"
                [closeOnSelect]="true"
                [items]="externalInstructors"
                [multiple]="false"
                [placeholder]="'Select Options' | translate"
                [searchable]="true"
                bindLabel="fullName"
                bindValue="id"
                class="custom"
                formControlName="externalInstructorId"
                id="externalInstructors"
                name="externalInstructors"
              >
              </ng-select>
              <app-form-error [control]="form.get('externalInstructorId')" [name]="'Instructor' | translate"></app-form-error>
            </div>
          }

          @if (selectedInstructorDetails) {
            <div class="weekdays-availability">
              <div>
                <h5 translate>Instructor Availability</h5>
                <ul>
                  @for (weekday of instructorAvailability; let i = $index; track weekday.id) {
                    <li>
                      <b>
                        @if (i === 0 || weekday.name !== instructorAvailability[i - 1].name) {
                          {{ weekday.name }}
                        }
                      </b>
                      {{ weekday.time }}
                    </li>
                  }
                </ul>
              </div>
              @if (instructorBookings && instructorBookings.length) {
                <div>
                  <h5 translate>Instructor Current Bookings</h5>
                  <ng-container>
                    <ul>
                      @for (booking of instructorBookings; track booking.id + $index) {
                        <li>
                          <b>
                            {{ booking.day }} <br />
                            <small class="text-orange">({{ booking.date | date: 'dd.MM.y' }})</small>
                          </b>
                          <b>{{ booking?.courseName }}</b>
                          {{ booking.time }}
                        </li>
                      }
                    </ul>
                  </ng-container>
                </div>
              }
            </div>
          }

          <!-- Description -->
          <div class="input-group --required">
            <label for="description" translate>Description</label>
            <textarea [placeholder]="'Enter Description' | translate" class="full-width-input" formControlName="description" id="description" name="description" rows="3"></textarea>
            <app-form-error [control]="form.get('description')" [name]="'Description' | translate"></app-form-error>
          </div>
          <!-- Weekdays -->
          <ng-container formArrayName="courseDate">
            <div class="input-group">
              <label translate>Course Date</label>
              <div class="input-groups-wrapper">
                @for (weekday of courseDateFormArray.controls; track weekday; let i = $index) {
                  <ng-container [formGroupName]="i">
                    <!-- Date -->
                    <div>
                      <div class="input-group --required">
                        <label for="courseDate-{{ i }}" translate>Date</label>
                        <app-date-picker-input [id]="'courseDate' + i" [pastDatesSelection]="false" formControlName="dateFrom" name="courseDate"></app-date-picker-input>
                        <app-form-error [control]="courseDateFormArray.controls[i].get('dateFrom')" [name]="'Date' | translate"></app-form-error>
                      </div>
                    </div>
                    <div class="flex-row-between-center gap-10">
                      <!--  Time From  -->
                      <div class="input-group --required">
                        <label for="startTime-{{ i }}" translate>Time From</label>
                        <app-time-picker-input [id]="'startTime-' + i" [name]="'startTime-' + i" class="full-width-input" formControlName="startTime"></app-time-picker-input>
                        <app-form-error [control]="courseDateFormArray.controls[i].get('startTime')" [name]="'Time From' | translate"></app-form-error>
                      </div>
                      <!-- Time TO -->
                      <div class="input-group --required">
                        <label for="endTime-{{ i }}" translate>Time To</label>
                        <app-time-picker-input
                          [id]="'endTime-' + i"
                          [name]="'endTime-' + i"
                          [previousSelectedTime]="courseDateFormArray.controls[i].get('startTime').value"
                          class="full-width-input"
                          formControlName="endTime"
                        ></app-time-picker-input>
                        <app-form-error [control]="courseDateFormArray.controls[i].get('endTime')" [name]="'Time To' | translate"></app-form-error>
                      </div>
                    </div>
                  </ng-container>
                  <div class="flex-row-end-center gap-6 mt-12">
                    @if (i === courseDateFormArray.controls.length - 1 && !allDaysSelected) {
                      <button (click)="addWeekdaysRow()" [tippy]="'Add' | translate" class="button button-simple button-icon-only">
                        <app-icon [cssStyle]="{ marginTop: '-2px' }" iconName="add" size="20px"></app-icon>
                      </button>
                    }
                    @if (courseDateFormArray.controls.length > 1) {
                      <button (click)="removeWeekdaysRow(i)" [tippy]="'Remove' | translate" class="button button-simple button-icon-only">
                        <app-icon [cssStyle]="{ marginTop: '-2px' }" iconName="trash-bin" size="20px"></app-icon>
                      </button>
                    }
                  </div>
                }
              </div>
            </div>
          </ng-container>

          <!--  Repeat Course  -->
          @if (isSingleValidTimeTo) {
            <div class="input-group --required">
              <label for="repeatCourse" translate>Repeat Course</label>
              <app-dropdown [options]="repeatCourse" bindValue="value" displayName="key" formControlName="repeatCourse" id="repeatCourse" name="repeatCourse"></app-dropdown>
              <app-form-error [control]="form.get('repeatCourse')" [name]="'Repeat Course' | translate"></app-form-error>
            </div>
          }

          <!-- Repeat Course End Date -->
          @if (showEndDate) {
            <div class="input-group --required">
              <label for="repeat-course-end-date" translate>End Date</label>
              <app-date-picker-input
                [pastDatesSelection]="false"
                [preSelectedDate]="courseDateFormArray?.controls[0]?.get('dateFrom').value"
                formControlName="repeatEndDate"
                id="repeat-course-end-date"
                name="repeat-course-end-date"
              ></app-date-picker-input>
              <app-form-error [control]="form.get('repeatEndDate')" [name]="'End Date' | translate"></app-form-error>
            </div>
          }

          <!-- Visibility of Course -->
          <div class="input-group --required">
            <label for="visibility" translate>Visibility</label>
            <app-dropdown [options]="visibilityOfCourse" bindValue="value" displayName="key" formControlName="visibility" id="visibility" name="visibility"></app-dropdown>
            <app-form-error [control]="form.get('visibility')" [name]="'Visibility' | translate"></app-form-error>
          </div>

          <!-- Course Users -->
          @if (form.get('visibility').value === EventVisibility.Private || form.get('visibility').value === EventVisibility.Public) {
            <div class="input-group" [class.--required]="form.get('visibility').value === EventVisibility.Private">
              <label for="tags" translate>Invite Participants</label>
              <ng-select
                [closeOnSelect]="true"
                [items]="users"
                [multiple]="true"
                [placeholder]="'Select Options' | translate"
                [searchable]="true"
                bindLabel="fullName"
                bindValue="id"
                class="custom"
                dropdownPosition="top"
                formControlName="participants"
                id="users"
                name="users"
              >
                <ng-template ng-footer-tmp>
                  <button (click)="selectAllParticipants()" class="button button-small button-outline-primary" translate>Select all</button>
                  <button (click)="unSelectAll()" class="button button-small button-simple" translate>Unselect all</button>
                </ng-template>
              </ng-select>
              <app-form-error [control]="form.get('participants')" [name]="'Participants' | translate"></app-form-error>
            </div>
          }

          <!-- Groups -->
          @if (form.get('visibility').value === EventVisibility.Group) {
            <div class="input-group --required">
              <label for="groupId" translate>Group</label>
              <app-dropdown [options]="groups" bindValue="id" displayName="name" formControlName="groupId" id="groupId" name="groupId"></app-dropdown>
              <app-form-error [control]="form.get('groupId')" [name]="'Group' | translate"></app-form-error>
            </div>
          }

          <!-- Room -->
          <div class="input-group --required">
            <label for="room" translate>Room</label>
            <app-dropdown [options]="rooms" bindValue="id" displayName="key" formControlName="room" id="room" name="room"></app-dropdown>
            <app-form-error [control]="form.get('room')" [name]="'Rooms' | translate"></app-form-error>
          </div>

          @if (selectedRoomDetails) {
            <div class="weekdays-availability">
              <div>
                <h5 translate>Room Availability</h5>
                @if (roomAvailability | slice: 0 : 10; as slicedAvailability) {
                  <ul>
                    @for (weekday of slicedAvailability; track weekday.id; let i = $index) {
                      <li>
                        <b>
                          @if (i === 0 || weekday.name !== slicedAvailability[i - 1].name) {
                            {{ weekday.name }}
                          }
                        </b>
                        {{ weekday.time }}
                      </li>
                    }
                  </ul>
                }
              </div>
              <div>
                <h5 translate>Room Capacity</h5>
                <div class="flex-row-between-center">
                  <b>{{ selectedRoomDetails.noOfPersons }} {{ 'Allowed Persons' | translate }}</b>
                </div>
              </div>
              @if (selectedRoomDetails.price) {
                <div>
                  <h5 translate>Room Charges</h5>
                  <div class="flex-row-between-center">
                    <b>€ {{ selectedRoomDetails.price || 0 }}</b>
                  </div>
                </div>
              }
              @if (roomBookings && roomBookings.length) {
                <div>
                  <h5 translate>Room Current Bookings</h5>
                  <ul>
                    @for (booking of roomBookings; track booking.id + $index) {
                      <li>
                        <b>
                          {{ booking.day }} <br />
                          <small class="text-orange">({{ booking.date | date: 'dd.MM.y' }})</small>
                        </b>
                        <b>
                          {{ booking?.courseName }}
                        </b>
                        {{ booking.time }}
                      </li>
                    }
                  </ul>
                </div>
              }
            </div>
          }

          <!-- Allowed Persons -->
          <div class="input-group --required">
            <label for="allowedPersons" translate>Allowed Persons</label>
            <input [placeholder]="'Allowed Persons' | translate" class="full-width-input" formControlName="allowedPersons" id="allowedPersons" name="allowedPersons" type="number" />
            <app-form-error [control]="form.get('allowedPersons')" [name]="'Allowed Persons' | translate"></app-form-error>
          </div>

          <!-- Choose File -->
          <div class="flex-row-start-center gap-10">
            @if (_currentSelectedCourse?.document) {
              <button
                (click)="downloadDocument(_currentSelectedCourse)"
                [disabled]="loadings.downloadingDocument"
                [tippy]="'Download File' | translate"
                class="button button-simple button-icon-only mt-8"
              >
                <app-icon iconName="download"></app-icon>
              </button>
              <button (click)="deleteFile(_currentSelectedCourse)" [disabled]="loadings.deletingDocument" [tippy]="'Delete File' | translate" class="button button-simple button-icon-only mt-8">
                <app-icon iconName="trash"></app-icon>
              </button>
            }
            <div class="w-100">
              <app-file-selector-input (attachmentSelected)="selectedAttachment = $event"></app-file-selector-input>
            </div>
          </div>

          <!--  Show Guests  -->
          <div class="input-group flex-row-start-center gap-14">
            <input class="toggle-btn" formControlName="showGuestList" id="showGuests" name="showGuests" type="checkbox" />
            <label class="reset-margin-bottom" for="showGuests" translate>Show Guests</label>
            <!--      <app-form-error [control]="form.get('showGuestList')" [name]="'Show Guests' | translate"></app-form-error>-->
          </div>

          <!--  Chargeable  -->
          <div class="align-chargeable-field">
            <div class="input-group flex-row-start gap-14">
              <input class="toggle-btn" formControlName="chargeable" id="chargeAble" name="chargeAble" type="checkbox" />
              <label class="reset-margin-bottom" for="chargeAble" translate>Chargeable</label>
              <!--      <app-form-error [control]="form.get('chargeAble')" [name]="'Chargeable' | translate"></app-form-error>-->
            </div>
            <!-- Enter Price -->
            @if (form.get('chargeable').value) {
              <div class="input-group">
                <label for="price" translate>Enter Price</label>
                <input [placeholder]="'Enter Price' | translate" appNumberInput formControlName="pricePerParticipant" id="price" name="price" type="number" />
                <!--      <app-form-error [control]="form.get('price')" [name]="'Price' | translate"></app-form-error>-->
              </div>
            }
          </div>
        </div>
        <div>
          <!-- Assign a task to an Course -->
          <div class="input-group flex-row-start-center gap-14">
            <input class="toggle-btn" formControlName="isTask" id="assignTaskToEvent" name="assignTaskToEvent" type="checkbox" />
            <label class="reset-margin-bottom" for="assignTaskToEvent" translate>Assign a task to course</label>
          </div>
          @if (form.get('isTask').value) {
            <div class="showAssignTaskForm" formGroupName="task">
              <!-- Title -->
              <div class="input-group --required">
                <label for="title" translate>Title</label>
                <input [placeholder]="'Title' | translate" class="full-width-input" formControlName="title" id="title" name="title" type="text" />
                <app-form-error [control]="form.get('task.title')" [name]="'Title' | translate"></app-form-error>
              </div>
              <!-- Description -->
              <div class="input-group --required">
                <label for="description" translate>Task Description</label>
                <textarea [placeholder]="'Task Description' | translate" class="full-width-input" formControlName="description" id="taskDescription" name="taskDescription" rows="3"></textarea>
                <app-form-error [control]="form.get('task.description')" [name]="'Task Description' | translate"></app-form-error>
              </div>
              <!-- Task Types -->
              <div class="input-group --required">
                <label for="taskType" translate>Task Types</label>
                <app-dropdown [options]="taskTypes" bindValue="value" displayName="key" formControlName="type" id="taskType" name="taskType"></app-dropdown>
                <app-form-error [control]="form.get('task.type')" [name]="'Task Type' | translate"></app-form-error>
              </div>
              <!-- Participants -->
              @if (form.get('task.type').value === EventTaskType.Individual) {
                <div class="input-group --required">
                  <label for="taskParticipants" translate>Participants</label>
                  <ng-select
                    [closeOnSelect]="true"
                    [items]="users"
                    [multiple]="true"
                    [placeholder]="'Select Options' | translate"
                    [searchable]="true"
                    bindLabel="fullName"
                    bindValue="id"
                    class="custom"
                    dropdownPosition="top"
                    formControlName="userSelect"
                    id="taskParticipants"
                    name="taskParticipants"
                  >
                    <ng-template ng-footer-tmp>
                      <button (click)="selectAllParticipants(true)" class="button button-small button-outline-primary" translate>Select all</button>
                      <button (click)="unSelectAll(true)" class="button button-small button-simple" translate>Unselect all</button>
                    </ng-template>
                  </ng-select>
                  <app-form-error [control]="form.get('userSelect')" [name]="'Participants' | translate"></app-form-error>
                </div>
              }
              <!-- Groups -->
              @if (form.get('task.type').value === EventTaskType.Group) {
                <div class="input-group --required">
                  <label for="taskGroupId" translate>Group</label>
                  <app-dropdown [dropdownPosition]="'top'" [options]="groups" bindValue="id" displayName="name" formControlName="groupId" id="taskGroupId" name="taskGroupId"></app-dropdown>
                  <app-form-error [control]="form.get('groupId')" [name]="'Group' | translate"></app-form-error>
                </div>
              }
              <!-- Date Picker  -->
              <div class="input-group --required">
                <label for="endDate" translate>End Date</label>
                <app-date-picker-input [pastDatesSelection]="false" formControlName="date" id="endDate" name="endDate"></app-date-picker-input>
                <app-form-error [control]="form.get('task.date')" [name]="'End Date' | translate"></app-form-error>
              </div>
            </div>
          }
        </div>
      </div>
    </form>
  </div>

  <footer>
    <div class="dialog__footer">
      @if (!isMobileView()) {
        <div class="dialog__footer__buttons">
          <app-button (click)="close()" [idleText]="'Cancel' | translate" [inlineStyle]="{ border: '1px solid var(--gray)' }" cssClass="button-simple"></app-button>
          <app-button (clickEvent)="save($event)" [disabled]="form.pristine && !selectedAttachment" [idleText]="(_currentSelectedCourse ? 'Update' : 'Save') | translate"></app-button>
        </div>
      }
    </div>
    @if (isMobileView()) {
      <div class="mobile-button mb-34 mx-16">
        <app-button
          (clickEvent)="save($event)"
          [disabled]="form.pristine && !selectedAttachment"
          [idleText]="(_currentSelectedCourse ? 'Update' : 'Save') | translate"
          cssClass="button-primary button-full"
        ></app-button>
      </div>
    }
  </footer>
</div>
